import React from "react";
import Countdown from "react-countdown";

const renderer = ({ days, hours, minutes, seconds, completed, className }) => {
	hours = days * 24 + hours;
	return (
		<div className={`countdown ${className}`}>
			<div className="item">
				<div>
					<div className="subtitle">
						{completed ? "00" : hours < 10 ? `0${hours}` : hours}
					</div>
					<span>Hours</span>
				</div>
			</div>
			<div className="item">
				<div>
					<div className="subtitle">
						{completed ? "00" : minutes < 10 ? `0${minutes}` : minutes}
					</div>
					<span>Mins</span>
				</div>
			</div>
			<div className="item">
				<div>
					<div className="subtitle">
						{completed ? "00" : seconds < 10 ? `0${seconds}` : seconds}
					</div>
					<span>Sec</span>
				</div>
			</div>
		</div>
	);
};
const CountdownItem = ({ targetDate }) => {
	const convertDate = (date, tzString) => {
		return new Date(
			(typeof date === "string" ? new Date(date) : date).toLocaleString(
				"en-US",
				{ timeZone: tzString }
			)
		);
	};
	return (
		<Countdown
			date={convertDate(targetDate, "Asia/singapore")}
			renderer={renderer}
		/>
	);
};

export default CountdownItem;
